export const types = [
    { value: 'json', displayValue: 'JSON' },
    { value: 'xlsx', displayValue: 'XLSX' },
];

export const productOverviewOutputMode = [
    { value: 'download', displayValue: 'Download' },
    { value: 'email', displayValue: 'Send by Email' }
];
